import {
  CreateTipoExclusaoDto,
  GetTipoExclusaoDTO,
} from "../shared/dtos/TipoExclusao.dto";
import api from "./api"; // A instância do Axios ou outro cliente HTTP configurado

// Classe para lidar com as operações relacionadas aos tipos de exclusão
class TipoExclusaoService {
  // Método para buscar os tipos de exclusão
  async getAll(): Promise<GetTipoExclusaoDTO[]> {
    return api
      .get<GetTipoExclusaoDTO[]>("/tipo-exclusao/findAll") // URL da API que retorna os tipos de exclusão
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // Tratamento de erro para falhas de comunicação com a API
        if (error.response) {
          console.error(
            "Erro ao buscar tipos de exclusão:",
            error.response.data
          );
          return Promise.reject(error.response.data);
        } else {
          console.error("Erro de rede ou outro problema:", error.message);
          return Promise.reject(error.message);
        }
      });
  }

  // Método para criar um novo tipo de exclusão
  async createTipoExclusao(
    nome: string,
    descricao: string,
    ativo: boolean
  ): Promise<GetTipoExclusaoDTO> {
    const data: CreateTipoExclusaoDto = {
      nome,
      descricao,
    };

    return api
      .post<GetTipoExclusaoDTO>("/tipos-exclusao/create", data)
      .then((response) => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          console.error("Erro ao criar tipo de exclusão:", response.data);
          return Promise.reject("Erro ao criar tipo de exclusão.");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("Erro ao criar tipo de exclusão:", error.response.data);
          return Promise.reject(error.response.data);
        } else {
          console.error("Erro de rede ou outro problema:", error.message);
          return Promise.reject(error.message);
        }
      });
  }

  // Método para excluir um tipo de exclusão
  //   async deleteTipoExclusao(id: number): Promise<boolean> {
  //     return api
  //       .delete(`/tipos-exclusao/delete/${id}`)
  //       .then((response) => {
  //         if (response.data.status === true) {
  //           return Promise.resolve(true);
  //         } else {
  //           console.error("Erro ao excluir tipo de exclusão:", response.data.message);
  //           return Promise.reject(response.data.message || "Erro desconhecido");
  //         }
  //       })
  //       .catch((error) => {
  //         if (error.response) {
  //           console.error("Erro ao excluir tipo de exclusão:", error.response.data);
  //           return Promise.reject(error.response.data);
  //         } else {
  //           console.error("Erro de rede ou outro problema:", error.message);
  //           return Promise.reject(error.message);
  //         }
  //       });
  //   }
}

// Criar uma instância do serviço
const tipoExclusaoService = new TipoExclusaoService();
export default tipoExclusaoService;
